import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'UNION_UPDATE',
    smsDelete : 'UNION_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        union: [],

        submitSuccess: false,
        unionLoading: false,
        unionError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_UNION(state, union) {
            state.union = union;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        UNION_LOADING (state, loading) {
            state.unionLoading = loading;
        },

        UNION_ERROR (state, hasError) {
            state.unionError = hasError;
        }
    },

    actions: {
        async addUnion ({commit, dispatch}, payload) {
            commit('UNION_LOADING', true);
            commit('UNION_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_union, payload.union, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchUnion')
                return response

            } catch (e) {
                commit('UNION_ERROR', true);
            } finally {
                commit('UNION_LOADING', false);
            }
        },

        async fetchUnion ({ commit }) {
            commit('UNION_LOADING', true);
            commit('UNION_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.union_list, config);
                let response = result.data
                commit('SET_UNION', response.data);

            } catch(error) {
                commit('UNION_ERROR', true);
            } finally {
                commit('UNION_LOADING', false);
            }
        },

        async getUnionsByUpazila ({ commit }, payload) {
            commit('UNION_LOADING', true);
            commit('UNION_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.union_list_by_upazila + payload, config);
                let response = result.data
                commit('SET_UNION', response.data);

            } catch(error) {
                commit('UNION_ERROR', true);
            } finally {
                commit('UNION_LOADING', false);
            }
        },

        async updateUnion ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.post(V1API.update_union + payload.id, payload.union, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchUnion')
                return response

            } catch (e) {
                commit('UNION_ERROR', true);
            } finally {
                commit('UNION_LOADING', false);
            }
        },
        
        async deleteUnion({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.union_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchUnion')
            return response
        }
    },

    getters: {}
}
